export const PipelineTemplates = {
  addExtendedAttributes: require('core/pipeline/config/stages/bake/modal/addExtendedAttribute.html'),
};
